import { createRouter, createWebHistory } from "vue-router";
import { createLocal } from 'the-storages';
const mirror = createLocal();
const storage = mirror._prx;
import Login from "../Pages/Auth/Login.vue";
import HomePage from "../Pages/index.vue";
import SignUp from "../Pages/Auth/SignUp.vue";
import Dashboard from "../Pages/AdminDashboard/Dashboard.vue";
import BasicForm from "../Pages/AdminDashboard/BasicForm.vue";
import AttendanceManagement from "../Pages/Settings/AttendanceManagement.vue";
import LeaveManagement from "../Pages/Settings/LeaveManagement.vue";
import Addnewemployee from "../Pages/AdminDashboard/Addemployee.vue";
import VerifyEmail from "../Pages/Auth/verifyemail.vue";
//import AddEmployeeMaster from "../Pages/AdminDashboard/AddEmployeeMaster.vue";
//import EmployeeDashboard from "../Pages/AdminDashboard/EmployeeDashboard.vue";
import CountryList from "../Pages/Masters/CountryList.vue";
import StateList from "../Pages/Masters/StateList.vue";
import AddCountry from "../Pages/Masters/AddCountry.vue";
import AddState from "../Pages/Masters/AddState.vue";
import DepartmentList from "../Pages/Masters/DepartmentList.vue";
import DesignationList from "../Pages/Masters/DesignationList.vue";
import ReportingManagerList from "../Pages/Masters/ReportingManagerList.vue";
import HolidayList from "../Pages/Masters/HolidayList.vue";
import EducationList from "../Pages/Masters/EducationList.vue";

import AttendanceSetting from "../Pages/Settings/AttendanceSetting.vue";
import GeneralSetting from "../Pages/Settings/GeneralSetting.vue";
import OrganizationSetting from "../Pages/Settings/OrganizationSetting.vue";
import LeaveSetting from "../Pages/Settings/LeaveSetting.vue";
import PayrollSetting from "../Pages/Settings/Payroll.vue";
import RoleAllocationSetting from "../Pages/Settings/RoleAllocationSetting.vue";
import EmployeeList from "../Pages/AdminDashboard/EmployeeList.vue";

import AttendanceAdjustment from "../Pages/Settings/AttendanceAdjustment.vue";
import LeaveDetails from "../Pages/Settings/LeaveDetails.vue";
import LeaveReport from "../Pages/Settings/LeaveReport.vue";
import LeaveStatus from "../Pages/Settings/LeaveStatus.vue";
import LeaveListing from "../Pages/Settings/LeaveListing.vue";
import AttendanceReport from "../Pages/Settings/AttendanceReport.vue";
import AttendanceDetails from "../Pages/Settings/AttendanceDetails.vue";
import LeaveCarryForwardPayouts from "../Pages/Settings/LeaveCarryForwardPayouts.vue"

import EditEmployee from "../Pages/AdminDashboard/EditEmployee.vue"
import ViewEmployeeDetails from "../Pages/Settings/ViewEmployeeDetails.vue";
import WFHReport from "../Pages/Settings/WFHReport.vue";
import DateChangeReport from "../Pages/Settings/DateChange.vue";
import Branch from "../Pages/Masters/Branch.vue";

import LeaveCarryAdmin from "../Pages/Settings/LeaveCarryAdmin.vue"

import SalarySlipApproval from "../Pages/Settings/SalarySlipApproval.vue";
import CalculateNetPay from "../Pages/Settings/CalculateNetPay.vue";
import Announcement from "../Pages/Settings/Announcement.vue";
import ForgotPassword from "../Pages/Auth/ForgotPassword.vue";
import ResetPassword from "../Pages/Auth/ResetPassword.vue";

// Import all your components...
// [Keep all your existing component imports]

const routes = [
    // Public routes (no auth required)
    {
        name: "HomePage",
        component: HomePage,
        path: "/",
        meta: { requiresAuth: false }
    },
    {
        name: "LogIn",
        component: Login,
        path: "/login",
        meta: { requiresAuth: false }
    },
    {
        name: "SignUp",
        component: SignUp,
        path: "/sign-up",
        meta: { requiresAuth: false }
    },
    {
        name: "VerifyEmail",
        component: VerifyEmail,
        path: "/verifyYourEmail/:id",
        meta: { requiresAuth: false }
    },

    // Admin dashboard route
    {
        name: "AdminDashboard",
        component: Dashboard,
        path: "/dashboard/:id",
        meta: { 
            requiresAuth: false,
            //permission: 'admin_dashboard'
        }
    },

    {
        name: "BasicForm",
        component: BasicForm,
        path: "/basicform/:id",
        meta: { 
            requiresAuth: true
            // No specific permission required
        }
    },

    // Employee management routes
    {
        name: "AttendanceManagement",
        component: AttendanceManagement,
        path: "/attendance",
        meta: { 
            requiresAuth: true,
            //permission: 'admin_dashboard'
        }
    },
    {
        name: "LeaveManagement",
        component: LeaveManagement,
        path: "/leave",
        meta: { 
            requiresAuth: true,
            //permission: 'admin_dashboard'
        }
    },
    {
        name: "Add-new-employee",
        component: Addnewemployee,
        path: "/add-employee",
        meta: { 
            requiresAuth: true,
            permission: 'add_employee'
        }
    },
    {
        name: "EmployeeList",
        component: EmployeeList,
        path: "/employee-list",
        meta: { 
            requiresAuth: true,
            permission: 'employee_list'
        }
    },
    {
        name: "EditEmployee",
        component: EditEmployee,
        path: "/edit-employee-details/:slug",
        meta: { 
            requiresAuth: true,
            permission: 'update_employee'
        }
    },
    {
        name: "ViewEmployeeDetails",
        component: ViewEmployeeDetails,
        path: "/view-employee-details/:slug",
        meta: { 
            requiresAuth: true,
            permission: 'view_employee'
        }
    },

    // Master settings routes
    {
        name: "CountryList",
        component: CountryList,
        path: "/country-list",
        meta: { 
            requiresAuth: true,
            permission: 'country'
        }
    },
    {
        name: "StateList",
        component: StateList,
        path: "/state-list",
        meta: { 
            requiresAuth: true,
            permission: 'state'
        }
    },
    {
        name: "AddCountry",
        component: AddCountry,
        path: "/add-country",
        meta: { requiresAuth: true }
    },
    {
        name: "AddState",
        component: AddState,
        path: "/add-state",
        meta: { requiresAuth: true }
    },
    {
        name: "DepartmentList",
        component: DepartmentList,
        path: "/department-list",
        meta: { 
            requiresAuth: true,
            permission: 'department'
        }
    },
    {
        name: "DesignationList",
        component: DesignationList,
        path: "/designation-list",
        meta: { 
            requiresAuth: true,
            permission: 'designation'
        }
    },
    {
        name: "ReportingManagerList",
        component: ReportingManagerList,
        path: "/reporting-manager-list",
        meta: { 
            requiresAuth: true,
            permission: 'reporting_manager'
        }
    },
    {
        name: "HolidayList",
        component: HolidayList,
        path: "/holiday-list",
        meta: { 
            requiresAuth: true,
            permission: 'holiday_master'
        }
    },
    {
        name: "EducationList",
        component: EducationList,
        path: "/education-list",
        meta: { 
            requiresAuth: true,
            permission: 'education'
        }
    },
    {
        name: "Branch",
        component: Branch,
        path: "/branch",
        meta: { 
            requiresAuth: true,
            permission: 'branch_master'
        }
    },

    // Settings routes
    {
        name: "OrganizationSetting",
        component: OrganizationSetting,
        path: "/organization-setting",
        meta: { 
            requiresAuth: true,
            permission: 'organization_settings'
        }
    },
    {
        name: "RoleAllocationSetting",
        component: RoleAllocationSetting,
        path: "/role-allocation-setting",
        meta: { 
            requiresAuth: true,
            permission: 'role_allocation_settings'
        }
    },
    {
        name: "AttendanceSetting",
        component: AttendanceSetting,
        path: "/attendance-setting",
        meta: { 
            requiresAuth: true,
            permission: 'attendance_settings'
        }
    },
    {
        name: "AttendanceAdjustment",
        component: AttendanceAdjustment,
        path: "/attendance-adjustment",
        meta: { 
            requiresAuth: true,
            permission: 'attendance_adjustment'
        }
    },
    {
        name: "AttendanceReport",
        component: AttendanceReport,
        path: "/attendance-report",
        meta: { 
            requiresAuth: true,
            permission: 'attendance_report'
        }
    },
    {
        name: "WFHReport",
        component: WFHReport,
        path: "/wfh-report",
        meta: { 
            requiresAuth: true,
            permission: 'wfh_report'
        }
    },
    {
        name: "DateChangeReport",
        component: DateChangeReport,
        path: "/date-change-report",
        meta: { 
            requiresAuth: true,
            permission: 'date_change_report'
        }
    },   
    {
        name: "LeaveDetails",
        component: LeaveDetails,
        path: "/leave-details/:id",
        meta: { 
            requiresAuth: true,
        }
    },
    {
        name: "LeaveSetting",
        component: LeaveSetting,
        path: "/leave-setting",
        meta: { 
            requiresAuth: true,
            permission: 'leave_settings'
        }
    },
    {
        name: "LeaveEdit",
        component: LeaveSetting,
        path: "/leave-setting/:id",
        meta: { 
            requiresAuth: true,
            permission: 'leave_settings'
        }
    },
    {
        name: "LeaveReport",
        component: LeaveReport,
        path: "/leave-report",
        meta: { 
            requiresAuth: true,
            permission: 'leave_report'
        }
    },
    {
        name: "LeaveStatus",
        component: LeaveStatus,
        path: "/leave-status",
        meta: { 
            requiresAuth: true,
            permission: 'leave_status'
        }
    },
    {
        name: "LeaveListing",
        component: LeaveListing,
        path: "/leave-listing",
        meta: { 
            requiresAuth: true,
            permission: 'leave_listing'
        }
    },
    {
        name: "LeaveCarryForwardPayouts",
        component: LeaveCarryForwardPayouts,
        path: "/leave-carry-forward-&-payouts",
        meta: { 
            requiresAuth: true,
            permission: 'leave_carry_forward'
        }
    },
    {
        name: "LeaveCarryAdmin",
        component: LeaveCarryAdmin,
        path: "/leave-carry-admin-adjustment",
        meta: { 
            requiresAuth: true,
            permission: 'leave_carry_admin'
        }
    },
    {
        name: "PayrollSetting",
        component: PayrollSetting,
        path: "/payroll-setting",
        meta: { 
            requiresAuth: true,
            permission: 'payroll_settings'
        }
    },
    {
        name: "CalculateNetPay",
        component: CalculateNetPay,
        path: "/calculate-net-pay",
        meta: { 
            requiresAuth: true,
            permission: 'view_employee_payroll'
        }
    },
    {
        name: "SalarySlipApproval",
        component: SalarySlipApproval,
        path: "/salary-slip-approval",
        meta: { 
            requiresAuth: true,
            permission: 'view_employee_salary'
        }
    },
    {
        name: "Announcement",
        component: Announcement,
        path: "/announcement",
        meta: { 
            requiresAuth: true,
            permission: 'announcement'
        }
    },
    {
        name: "AttendanceDetails",
        component: AttendanceDetails,
        path: "/attendance-details/:slug",
        meta: { 
            requiresAuth: true,
        }
    },
    {
        name: "GeneralSetting",
        component: GeneralSetting,
        path: "/general-setting",
        meta: { 
            requiresAuth: true,
        }
    },
    {
        name: "ForgotPassword",
        component: ForgotPassword,
        path: "/forgot-password",
        meta: { requiresAuth: false }
    },
    {
        name: "ResetPassword",
        component: ResetPassword,
        path: "/reset-password",
        meta: { requiresAuth: false }
    },
    // Keep other routes that don't need specific permissions
    // [Rest of your routes...]
];

const router = createRouter({
    mode: "history",
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active", 
    linkExactActiveClass: "active", 
});

// Navigation guard to check permissions
router.beforeEach((to, from, next) => {
    const role = storage.role;
    const isAuthenticated = storage.token;

    // Check if route requires authentication
    if (to.meta.requiresAuth && !isAuthenticated) {
        return next('/login');
    }

    // Check if user has permission to access the route
    if (to.meta.permission) {
        if (!role || (role.name !== 'Super Admin' && !role.permissions.includes(to.meta.permission))) {
            // Redirect to dashboard or show error
            return next('/dashboard/' + storage.companyDetails.id);
        }
    }

    // Allow navigation
    next();
});

export default router;